import ordersAndReturnService from './ordersAndReturn.service'

export default ordersAndReturnService
